// src/components/Common/Toast.js

import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import PropTypes from 'prop-types';

/**
 * Toast component displays individual toast notifications.
 */
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000); // Auto-dismiss after 5 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  // Define background colors based on toast type
  const bgColor =
    type === 'success'
      ? 'bg-green-600'
      : type === 'error'
      ? 'bg-red-600'
      : 'bg-blue-600'; // Default to blue for 'info' type

  return (
    <div
      className={`max-w-sm w-full ${bgColor} text-white px-4 py-3 rounded shadow-lg flex items-center justify-between animate-fadeIn`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{ whiteSpace: 'pre-wrap' }}
    >
      <span className="flex-1">{message}</span>
      <button
        onClick={onClose}
        aria-label="Close notification"
        className="ml-4 text-white hover:text-gray-200 focus:outline-none"
      >
        <FaTimes />
      </button>
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'info']),
  onClose: PropTypes.func.isRequired,
};

export default Toast;
